












/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Mixins, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import ProfileForm from '@part/profile/ProfileForm.vue';
import ProfileImageForm from '@part/profile/ProfileImageForm.vue';
import OrganisationList from "@part/profile/OrganisationList.vue";

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    components: {
        OrganisationList,
        ProfileImageForm,
        ProfileForm,
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Profile extends Vue {}

